import React from "react";
import { Box, Container, Link, Stack, Typography } from "@mui/material";
import useWPMenu from "../../hooks/useWPMenu";
import useWPSiteMeta from "../../hooks/useWPSiteMeta";
import useWPBranding from "../../hooks/useWPBranding";
import useLanguage from "../../hooks/useLanguage";
import { getFooterSectionTitle } from "../../utils/langSwitch";
import DefaultSiteIcon from "./DefaultSiteIcon";

const Footer = () => {
  const { lang, withLang } = useLanguage();
  const { items, loading, error } = useWPMenu("footer", lang);
  const meta = useWPSiteMeta();
  const branding = useWPBranding();
  const fallbackItems = [
    { id: "impressum", title: "Impressum", url: "/impressum" },
    { id: "datenschutz", title: "Datenschutz", url: "/datenschutz" }
  ];
  const sectionTitle = getFooterSectionTitle(lang);
  const footerLine =
    lang === "en"
      ? "A system that trusts people to choose."
      : "Ein System, das Menschen zutraut, zu entscheiden.";

  const menuItems = !error && items.length ? items : fallbackItems.map((item) => ({ ...item, url: withLang(item.url) }));
  const logoUrl = branding?.logo || meta?.site_icon_url;
  const logoAlt = branding?.siteName || meta?.name || "MultiSide";
  const hasLogo = Boolean(logoUrl);

  if (loading && !items.length) return null;

  return (
    <Box component="footer" sx={{ borderTop: "1px solid", borderColor: "divider", py: 4, mt: 6 }}>
      <Container maxWidth="lg">
        <Stack spacing={3}>
          <Box>
            {hasLogo ? (
              <Box component="img" src={logoUrl} alt={logoAlt} sx={{ height: 48 }} />
            ) : (
              <DefaultSiteIcon size={48} sx={{ color: "text.primary" }} label={logoAlt} />
            )}
          </Box>
          <Box>
            <Typography variant="subtitle2" sx={{ mb: 1, textTransform: "uppercase", letterSpacing: "0.12em" }}>
              {sectionTitle}
            </Typography>
            <Stack direction="column" spacing={1}>
              {menuItems.map((item) => (
                <Link key={item.id} href={item.url}>
                  {item.title}
                </Link>
              ))}
            </Stack>
          </Box>
        </Stack>
      </Container>
      <Box sx={{ mt: 4, py: 2, borderTop: "1px solid", borderColor: "divider" }}>
        <Container maxWidth="lg">
          <Typography variant="caption" color="text.secondary" align="center">
            {footerLine}
          </Typography>
        </Container>
      </Box>
    </Box>
  );
};

export default Footer;
